import React from "react";
import { BACKEND_URL } from "../../../lib/api";

export const shotUrl = (s, pending) => `${BACKEND_URL}/api/manual/media/${s.shot_id}/file?v=${s.version || 1}${pending ? "&pending=1" : ""}`;
const RED = "#dc2626";
const GOLD = "#a38243";

function Mark({ a, W, H }) {
  const x = a.x * W, y = a.y * H, w = (a.w || 0) * W, h = (a.h || 0) * H, lw = Math.max(3, W / 360), fs = Math.max(14, W / 60);
  if (a.kind === "rect" || a.kind === "highlight") return <rect x={Math.min(x, x + w)} y={Math.min(y, y + h)} width={Math.abs(w)} height={Math.abs(h)} fill="none" stroke={a.kind === "rect" ? RED : GOLD} strokeWidth={lw} rx={lw} />;
  if (a.kind === "arrow") return <line x1={x} y1={y} x2={x + w} y2={y + h} stroke={RED} strokeWidth={lw + 1} markerEnd="url(#lif-arrow)" />;
  if (a.kind === "marker") {
    const r = Math.max(16, W / 60);
    return <g><circle cx={x} cy={y} r={r} fill={GOLD} stroke="white" strokeWidth="2" /><text x={x} y={y} fill="white" fontSize={fs} fontWeight="700" textAnchor="middle" dominantBaseline="central">{a.n || 1}</text></g>;
  }
  if (a.kind === "text") {
    const tw = fs * 0.56 * (a.text || "").length + 20;
    return <g><rect x={x} y={y} width={tw} height={fs + 16} rx="6" fill="#1f1a14" /><text x={x + 10} y={y + 8 + fs * 0.82} fill="white" fontSize={fs}>{a.text}</text></g>;
  }
  return null;
}

// Screenshot with its annotations drawn as an SVG overlay (coordinates stored as 0–1 fractions).
export function AnnotatedShot({ s, anns, draft, pending, className = "", svgProps = {}, testid }) {
  const W = s.width || 1440, H = s.height || 900;
  return (
    <div className={`relative select-none ${className}`} data-testid={testid}>
      <img src={s.src ? `${BACKEND_URL}${s.src}` : shotUrl(s, pending)} alt={s.title || "Screenshot"} className="w-full h-auto block rounded-lg" draggable={false} loading="lazy" />
      <svg viewBox={`0 0 ${W} ${H}`} className="absolute inset-0 w-full h-full" {...svgProps}>
        <defs><marker id="lif-arrow" viewBox="0 0 10 10" refX="7" refY="5" markerWidth="6" markerHeight="6" orient="auto-start-reverse"><path d="M0 0 L10 5 L0 10 z" fill={RED} /></marker></defs>
        {(pending ? [] : anns || s.annotations || []).map((a, i) => <Mark key={i} a={a} W={W} H={H} />)}
        {draft && <Mark a={draft} W={W} H={H} />}
      </svg>
    </div>
  );
}
